import axios, { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { HttpParams, HttpResponse, UserHttpResponse } from '@/types';
import { getToken } from './index';
// import { showToast } from 'vant';

const service = axios.create({
	baseURL: import.meta.env.RS_BASE_URL,
});

const whiteList = [
	'/mobile/loginByEmpCode',
	'/mobile/sendLoginSmsCode',
	'/mobile/loginByPhone',
	'/mobile/loginByCode',
	'/mobile/wx/oauthUrl',
];

service.interceptors.request.use(
	(config: InternalAxiosRequestConfig) => {
		const url = config.url ? config.url.split('?')[0] : '';
		const token = getToken();
		if(token && !whiteList.includes(url)) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error: Error) => {
		return Promise.reject(error);
	}
);

service.interceptors.response.use(
	(response: AxiosResponse) => {
		const { code, msg } = response.data;
		// alert(msg);
		// showToast({
		// 	message: msg,
		// 	duration: 5000,
		// });
		if (code === 401 ) {
			// location.href = import.meta.env.RS_LOGIN_URL;
			return;
		}
		if (code === 500) {
			console.error(msg);
		}
		return response.data;
	},
	(error: { message: '', config: { url: '' } }) => {
		console.log('error', error);
	}
);

export class Request {
	instance: AxiosInstance;

	constructor() {
		this.instance = service;
	}

	get<T>(params: HttpParams): Promise<HttpResponse<T>> {
		return this.instance.get(params.url, {
			params: params.data,
		});
	}

	post<T>(params: HttpParams): Promise<HttpResponse<T>> {
		return this.instance.post(params.url, params.data);
	}

	put<T>(params: HttpParams): Promise<HttpResponse<T>> {
		return this.instance.put(params.url, params.data);
	}

	delete<T>(params: HttpParams): Promise<HttpResponse<T>> {
		return this.instance.delete(params.url, {
			data: params.data,
		});
	}

	userGet<T>(params: HttpParams): Promise<UserHttpResponse<T>> {
		return this.instance.get(params.url, {
			params: params.data,
		});
	}
}
